/**
 * Delete all duplicates from the original array
 * @param array
 * @returns
 */
export const uniq = <T>(array: T[]): T[] => [...new Set(array)];
